import { Wrench, Flame, Zap, Microwave, Utensils, Fan, Thermometer, Hammer, ArrowRight, PhoneCall, Building } from 'lucide-react';

const services = [
    {
        icon: <Hammer size={28} />,
        title: "RESIDENTIAL CONSTRUCTION",
        desc: "We provide premium residential construction services with best facilities to our clients. These services are provided by our team of professionals in accordance."
    },
    {
        icon: <Building size={28} />,
        title: "COMMERCIAL BUILDINGS",
        desc: "Our commercial construction services are provided to clients at budget-friendly market prices. These services are provided by our team of professionals in accordance. We also provide complete commercial building solutions to our clients."
    },
    {
        icon: <Wrench size={28} />,
        title: "INFRASTRUCTURE PROJECTS",
        desc: "We have a team of engineers with the necessary expertise, like project management, quality control and timely delivery in Lokesh Mandal Constructions for all infrastructure projects."
    },
    {
        icon: <Flame size={28} />,
        title: "RENOVATION SERVICES",
        desc: "We provide renovation and remodeling services with best facilities to our clients. These services are provided by our team of professionals in accordance."
    }
];

const HomeServices = () => {
    return (
        <section className="hob-services-section">
            <div className="hob-services-header">
                <h2 className="hob-services-heading">Our Services</h2>
                <p className="hob-services-subtext">We build your dream projects with expert engineers and trusted craftsmanship.</p>
            </div>
            <div className="hob-services-grid">
                {services.map((service, idx) => (
                    <div className="hob-service-card" key={idx}>
                        <div className="hob-service-icon">{service.icon}</div>
                        <h3 className="hob-service-title">{service.title}</h3>
                        <p className="hob-service-desc">{service.desc}</p>
                        <div className="hob-service-actions">
                            <span
                                className="hob-service-link"
                                onClick={() => (window.location.href = "tel:8433630912")}
                                style={{ cursor: "pointer" }}
                            >
                                <PhoneCall size={14} />Call Now
                            </span>
                        </div>
                    </div>
                ))}
            </div>
            
            <div className="hob-services-viewall">
                <span 
                    className="hob-viewall-btn"
                    onClick={() => window.location.href = '/service'}
                    style={{ cursor: "pointer" }}
                >
                    View All Services <ArrowRight size={18} />
                </span>
            </div>
        </section>
    );
};

export default HomeServices;